/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Should_The_Ai_Represent_TheInputs */

const en_how_should_the_ai_represent_the = /** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How should the AI represent this specific property? E.g. 'Focus on the privacy of the estate and the proximity to the marina.'`)
};

const id_how_should_the_ai_represent_the = /** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana AI harus merepresentasikan properti khusus ini? Mis. 'Fokus pada privasi perkebunan dan jarak ke marina.'`)
};

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const es_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const fr_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const de_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const ja_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const zh_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const ar_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const it_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const ru_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const pt_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/** @type {(inputs: How_Should_The_Ai_Represent_TheInputs) => LocalizedString} */
const ko_how_should_the_ai_represent_the = en_how_should_the_ai_represent_the;

/**
* | output |
* | --- |
* | "How should the AI represent this specific property? E.g. 'Focus on the privacy of the estate and the proximity to the marina.'" |
*
* @param {How_Should_The_Ai_Represent_TheInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const how_should_the_ai_represent_the = /** @type {((inputs?: How_Should_The_Ai_Represent_TheInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Should_The_Ai_Represent_TheInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_should_the_ai_represent_the(inputs)
	if (locale === "es") return es_how_should_the_ai_represent_the(inputs)
	if (locale === "fr") return fr_how_should_the_ai_represent_the(inputs)
	if (locale === "de") return de_how_should_the_ai_represent_the(inputs)
	if (locale === "ja") return ja_how_should_the_ai_represent_the(inputs)
	if (locale === "zh") return zh_how_should_the_ai_represent_the(inputs)
	if (locale === "ar") return ar_how_should_the_ai_represent_the(inputs)
	if (locale === "id") return id_how_should_the_ai_represent_the(inputs)
	if (locale === "it") return it_how_should_the_ai_represent_the(inputs)
	if (locale === "ru") return ru_how_should_the_ai_represent_the(inputs)
	if (locale === "pt") return pt_how_should_the_ai_represent_the(inputs)
	return ko_how_should_the_ai_represent_the(inputs)
});